import { type HttpInterceptorFn } from '@angular/common/http';
import { Logger } from '@shared/helpers/logger';

/**
 * Interceptor to log outgoing HTTP requests.
 * Follows minions-ui HttpLoggerInterceptor pattern.
 */
export const httpLoggerInterceptor: HttpInterceptorFn = (req, next) => {
  const logger = new Logger('HTTP Request');

  logger.log(`Out going request: ${req.url}`, {
    headers: req.headers,
    body: req.body,
    params: req.params,
  });

  return next(req);
};
